"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriorityCountriesMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CountryPicker = require("../CountryPicker.model");
var _Styled = require("./Styled");
// Interfaces:

var PriorityCountriesMobile = exports.PriorityCountriesMobile = function PriorityCountriesMobile(_ref) {
  var countries = _ref.countries,
    onClickDestination = _ref.onClickDestination;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Styled.StyledLabel, null, "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledPriorityList, null, countries.map(function (con) {
    return /*#__PURE__*/_react["default"].createElement(StyledPriorityCountry, {
      onClick: function onClick() {
        return onClickDestination(con);
      },
      key: con.name_ru
    }, /*#__PURE__*/_react["default"].createElement(PriorityCountryWrapper, null, /*#__PURE__*/_react["default"].createElement(_Styled.CountryName, {
      priority: true
    }, con.name_ru), /*#__PURE__*/_react["default"].createElement(_Styled.Visa, {
      noVisa: con.visaAvailability === _CountryPicker.NO_VISA
    }, con.visaAvailability)));
  })));
};
var StyledPriorityList = _styledComponents["default"].ul.withConfig({
  displayName: "PriorityCountriesmobile__StyledPriorityList",
  componentId: "sc-1b9z1z6-0"
})(["display:flex;flex-wrap:wrap;width:100%;"]);
var StyledPriorityCountry = _styledComponents["default"].li.withConfig({
  displayName: "PriorityCountriesmobile__StyledPriorityCountry",
  componentId: "sc-1b9z1z6-1"
})(["display:flex;justify-content:center;align-items:center;height:90px;flex:0 calc(50% - 4px);max-width:calc(50% - 4px);background-image:url(http://cdn.yc.level.travel/lt-modules-assets/seo/priority-country-mobile.jpg);background-size:cover;border-radius:4px;&:hover{cursor:pointer;}&:nth-child(2n-1){margin-right:8px;margin-bottom:8px;}&:last-child{margin-bottom:0;}"]);
var PriorityCountryWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PriorityCountriesmobile__PriorityCountryWrapper",
  componentId: "sc-1b9z1z6-2"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;border-radius:30px;height:48px;width:70%;background-color:#ffffff;"]);